module.exports = __webpack_public_path__ + "static/img/s06.ce4ba314.png";